<div class="form-field">
  <label *ngIf="!noLabel" [for]="id">{{ label }}</label>
  <div class="input-content" [class.with-prefix]="!!prefixIcon">
    <div *ngIf="prefixIcon" class="prefix-icon" aria-hidden="true">
      <mat-icon>{{ prefixIcon }}</mat-icon>
    </div>
    <ng-container *ngIf="type !== 'textarea'; else textareaBlock">
      <ng-container *ngIf="autocompleteAnchor">
        <ng-container *ngIf="mask; else noMaskAuto">
          <input
            [class.invalid]="!!error"
            [class.with-prefix]="!!prefixIcon"
            [class.size-small]="size === 'small'"
            [id]="id"
            [type]="!passwordInput ? type : visibleValue ? 'text' : 'password'"
            [placeholder]="placeholder ?? ''"
            [value]="value ?? ''"
            (input)="emitChange($any($event.target).value)"
            (focus)="emitFocus()"
            (focusout)="emitFocusOut()"
            [readOnly]="readonly"
            [disabled]="disabled"
            [matAutocomplete]="autocompleteAnchor"
            [mask]="mask"
            [style.cursor]="readonly || disabled ? 'not-allowed' : 'default'"
          />
        </ng-container>
        <ng-template #noMaskAuto>
          <input
            [class.invalid]="!!error"
            [class.with-prefix]="!!prefixIcon"
            [class.size-small]="size === 'small'"
            [id]="id"
            [type]="!passwordInput ? type : visibleValue ? 'text' : 'password'"
            [placeholder]="placeholder ?? ''"
            [value]="value ?? ''"
            (input)="emitChange($any($event.target).value)"
            (focus)="emitFocus()"
            (focusout)="emitFocusOut()"
            [readOnly]="readonly"
            [disabled]="disabled"
            [matAutocomplete]="autocompleteAnchor"
            [style.cursor]="readonly || disabled ? 'not-allowed' : 'default'"
            (keydown)="onTextareaKeydown($event)"
          />
        </ng-template>
      </ng-container>
      <ng-container *ngIf="!autocompleteAnchor">
        <ng-container *ngIf="mask; else noMask">
          <input
            [id]="id"
            [type]="!passwordInput ? type : visibleValue ? 'text' : 'password'"
            [name]="name"
            [value]="value ?? ''"
            (input)="emitChange($any($event.target).value)"
            (focus)="emitFocus()"
            (focusout)="emitFocusOut()"
            [readOnly]="readonly"
            [disabled]="disabled"
            [placeholder]="placeholder ?? ''"
            [class.invalid]="!!error"
            [class.with-prefix]="!!prefixIcon"
            [class.size-small]="size === 'small'"
            [mask]="mask"
            [style.cursor]="readonly || disabled ? 'not-allowed' : 'default'"
          />
        </ng-container>
        <ng-template #noMask>
          <input
            [id]="id"
            [type]="!passwordInput ? type : visibleValue ? 'text' : 'password'"
            [name]="name"
            [value]="value ?? ''"
            (input)="emitChange($any($event.target).value)"
            (focus)="emitFocus()"
            (focusout)="emitFocusOut()"
            [readOnly]="readonly"
            [disabled]="disabled"
            [placeholder]="placeholder ?? ''"
            [class.invalid]="!!error"
            [class.with-prefix]="!!prefixIcon"
            [class.size-small]="size === 'small'"
            [style.cursor]="readonly || disabled ? 'not-allowed' : 'default'"
          />
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-template #textareaBlock>
      <textarea
        [class.invalid]="!!error"
        [class.with-prefix]="!!prefixIcon"
        [class.size-small]="size === 'small'"
        [id]="id"
        [placeholder]="placeholder ?? ''"
        [value]="value ?? ''"
        (input)="emitChange($any($event.target).value)"
        (focus)="emitFocus()"
        (focusout)="emitFocusOut()"
        [readOnly]="readonly"
        [disabled]="disabled"
        *ngIf="!mask; else maskedTextarea"
        [style.cursor]="readonly || disabled ? 'not-allowed' : 'default'"
        rows="1"
        #autoGrowTextarea
        (input)="autoGrow(autoGrowTextarea)"
        (keydown)="onTextareaKeydown($event)"
      ></textarea>
      <ng-template #maskedTextarea>
        <textarea
          [class.invalid]="!!error"
          [class.with-prefix]="!!prefixIcon"
          [class.size-small]="size === 'small'"
          [id]="id"
          [placeholder]="placeholder ?? ''"
          [value]="value ?? ''"
          (input)="emitChange($any($event.target).value)"
          (focus)="emitFocus()"
          (focusout)="emitFocusOut()"
          [readOnly]="readonly"
          [disabled]="disabled"
          [mask]="mask"
          [style.cursor]="readonly || disabled ? 'not-allowed' : 'default'"
          rows="1"
          #autoGrowTextarea
          (input)="autoGrow(autoGrowTextarea)"
          (keydown)="onTextareaKeydown($event)"
        ></textarea>
      </ng-template>
    </ng-template>
    <button
      *ngIf="passwordInput"
      mat-icon-button
      class="password-visibility"
      (click)="visibleValue = !visibleValue"
      type="button"
    >
      <mat-icon>{{ visibleValue ? "visibility_off" : "visibility" }}</mat-icon>
    </button>
    <div *ngIf="showSuccessIcon" class="success-icon">
      <mat-icon>check</mat-icon>
    </div>
  </div>
  <!-- debug: shows the internal value managed by the ControlValueAccessor -->
  <!-- <div class="debug-value" style="font-size:12px;color:var(--muted,gray);margin-top:6px">debug value: "{{ value }}"</div> -->
  <p class="hint-error" *ngIf="error">{{ error }}</p>
</div>
